import { useQuery } from "@tanstack/react-query";
import { get } from "../components/utils/request";
import { useAuthStore } from "../stores/authStore";

const fetchTokensData = async ({ token }) => {
  const response = await get({
    path: "/client/properties/balance/properties/estate",
    token,
  });
  return response;
};

export const useTokensData = () => {
  const { auth } = useAuthStore();

  const tokensDataQuery = useQuery({
    queryKey: ["tokensData"],
    queryFn: () => fetchTokensData({ token: auth.accessToken }),
    refetchInterval: 1000 * 60 * 5,
    enabled: !!auth.accessToken,
  });

  return {
    tokensDataQuery,
  };
};
